module.exports = __webpack_public_path__ + "static/FrameCompanies-51c9e72e050aabb1e8b9a30e66c6ed4c.png";